import DatePicker from 'react-datepicker';
import styled from 'styled-components';

export const Wrapper = styled.div`
  background-color: #fff;
  width: 50%;
  box-shadow: 2px 6px 24px rgba(16, 40, 68, 0.2);
  max-height: 90%;
  overflow: auto;
  &::-webkit-scrollbar {
    /* WebKit */
    width: 0;
    height: 0;
  }
  border-radius: 8px;

  @media screen and (max-width: 1280px) {
    width: 90%;
  }
`;

export const TopText = styled.p`
  font-family: 'MontserratSemiBold';
  font-weight: 600;
  font-size: 16px;
  color: #09091a;
  padding: 20px 20px 20px 24px;
`;

export const Line = styled.div`
  width: 100%;
  height: 1px;
  background-color: #f4f4f4;
`;

export const ModalBlock = styled.div`
  overflow: scroll;
  height: auto;
  max-height: 600px;

  @media screen and (max-width: 1280px) {
    max-height: 400px;
  }
`;

export const Info = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 20px 20px 20px 24px;

  @media screen and (max-width: 600px) {
    flex-direction: column;
    padding: 16px;
  }
`;

export const Image = styled.img`
  width: 64px;
  height: 64px;
  border-radius: 50%;
  filter: blur(1px);
`;

export const ImageDefault = styled.div`
  width: 64px;
  height: 64px;
  border-radius: 50%;
  filter: blur(1px);
  background-color: #e9eaf8;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const ImageName = styled.p`
  font-family: 'Montserrat';
  font-weight: 400;
  font-size: 14px;
  letter-spacing: -1px;
  color: #09091a;
  text-transform: uppercase;
`;

export const ImageWrapper = styled.div`
  width: 64px;
  max-width: 64px;
  height: 64px;
  border-radius: 50%;
  margin-right: 40px;
  position: relative;
  cursor: pointer;

  @media screen and (max-width: 600px) {
    margin-bottom: 16px;
  }
`;

export const ImagePlace = styled.img`
  width: 100%;
  height: 100%;
  position: absolute;
  border-radius: 50%;
`;

export const EditIcon = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

export const ImageEmpty = styled.div`
  width: 75px;
  height: 64px;
  border-radius: 50%;
  margin-right: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #e9eaf8;
  overflow: hidden;
  position: relative;

  @media screen and (max-width: 600px) {
    margin-bottom: 16px;
  }
`;

export const AddPhoto = styled.input`
  width: 100%;
  height: 100%;
  overflow: hidden;
  opacity: 0;
  position: absolute;
  cursor: pointer;
  z-index: 100;
`;

export const InfoBlock = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const FlexField = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;

  @media screen and (max-width: 600px) {
    flex-direction: column;
  }
`;

export const DriverBlock = styled.p`
  font-family: 'MontserratBold';
  font-weight: 700;
  font-size: 12px;
  color: #9292a4;
  margin-bottom: 12px;
`;

export const InputField = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  margin-bottom: 8px;
`;

export const InputFieldHalf = styled.div`
  width: 49%;
  display: flex;
  flex-direction: column;
  position: relative;
  margin-bottom: 20px;

  @media screen and (max-width: 600px) {
    width: 100%;
  }
`;

export const InputDiv = styled.div`
  height: 41px;
  border: 1px solid #c6c7da;
  padding: 10px;
  margin-bottom: 12px;
  border-radius: 4px;
`;

export const InputLabel = styled.label`
  font-family: 'Montserrat';
  font-weight: 400;
  font-size: 16px;
  color: #09091a;
  margin-bottom: 8px;
`;

export const SelectedValue = styled.div`
  width: 100%;
  position: absolute;
  top: 90%;
  transform: translateY(-80%);
  left: 0;
  padding: 8px 16px;
  font-family: 'Montserrat';
  font-weight: 400;
  font-size: 16px;
  color: #09091a;
  background-color: #fff;
  border-radius: 4px;
  border: 1px solid #c6c7da;
  min-height: 41px;
`;

export const FieldIcon = styled.div`
  position: absolute;
  top: 85%;
  transform: translateY(-75%);
  right: 0;
  padding: 10px;
`;

export const InputDate = styled(DatePicker)`
  width: 100%;
  min-height: 41px;
  border: 1px solid #c6c7da;
  border-radius: 4px;
  font-family: 'Montserrat';
  font-weight: 400;
  font-size: 16px;
  color: #09091a;
  outline: none;
  padding: 7px 16px;
  background: transparent;
  cursor: pointer;
`;

export const InputSelect = styled.select`
  border: 1px solid #c6c7da;
  border-radius: 4px;
  outline: none;
  padding: 8px 16px;
  font-family: 'Montserrat';
  font-weight: 400;
  font-size: 16px;
  color: transparent;
  opacity: 0;
`;

export const Opt = styled.option`
  border: 1px solid #c6c7da;
  font-family: 'Montserrat';
  font-weight: 400;
  font-size: 16px;
  color: #09091a;
`;

export const Input = styled.input`
  width: 100%;
  font-family: 'Montserrat';
  font-weight: 400;
  font-size: 16px;
  margin-bottom: 8px;
  border: 1px solid #c6c7da;
  padding: 10px;
  outline: none;
  color: #09091a;
  margin-bottom: 12px;
  border-radius: 4px;

  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
`;

export const TextArea = styled.textarea`
  width: 100%;
  font-family: 'Montserrat';
  font-weight: 400;
  font-size: 16px;
  color: #09091a;
  margin-bottom: 8px;
  border: 1px solid #c6c7da;
  padding: 10px;
  outline: none;
  font-size: 16px;
  color: #09091a;
  margin-bottom: 12px;
`;

export const Required = styled.span`
  color: #9292a4;
`;

export const Bottom = styled.div`
  display: flex;
  justify-content: end;
  align-items: center;
  padding: 20px;
`;

export const Actions = styled.div`
  display: flex;
  align-items: center;
`;

export const Cancel = styled.button`
  color: #616172;
  font-family: 'MontserratSemiBold';
  font-weight: 600;
  font-size: 16px;
  outline: none;
  border: none;
  background: none;
  cursor: pointer;
  margin-right: 40px;
`;

export const Error = styled.span`
  position: absolute;
  bottom: -5px;
  font-family: 'Montserrat';
  font-weight: 400;
  font-size: 12px;
  color: #f30f00;
`;

export const TabWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: 1px solid #9292a4;
  border-radius: 4px;
  overflow: hidden;
`;

export const Tab = styled.div`
  text-align: center;
  width: 100%;
  padding: 9px 0;
  cursor: pointer;
  font-family: 'MontserratSemiBold';
  font-weight: 600;
  font-size: 16px;
`;

export const FieldFlex = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const IconField = styled.div`
  cursor: pointer;
`;

export const BlueButton = styled.p`
  font-family: 'MontserratBold';
  font-weight: 700;
  font-size: 12px;
  text-transform: uppercase;
  color: #0e71eb;
  cursor: pointer;
  padding-top: 21px;
`;

export const FlexColumn = styled.div`
  display: flex;
  flex-direction: column;
`;

export const FilePlace = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  background: #ffffff;
  border-radius: 8px;
  padding: 16px 0 0;
`;

export const InputFilePlace = styled.div`
  border: 2px dashed #c6c7da;
  min-height: 60px;
  border-radius: 4px;
  width: 100%;
  position: relative;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const InputFile = styled.input`
  width: 100%;
  height: 100%;
  position: absolute;
  opacity: 0;
  z-index: 1;
  cursor: pointer;
`;

export const InputPlace = styled.img`
  max-width: 100%;
  height: 100%;
  border-radius: 4px;
  z-index: 2;
`;

export const TextEmpty = styled.p`
  font-family: 'Montserrat';
  font-weight: 400;
  font-size: 14px;
  color: #616172;
  margin-left: 4px;
  word-break: break-word;
  width: 100%;
  padding-bottom: 21px;
`;

export const AttachFile = styled.div`
  margin-top: 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const DocumentName = styled.div`
  margin-top: 16px;
  display: flex;
  align-items: center;
`;

export const DocumentText = styled.p`
  font-family: 'Montserrat';
  font-weight: 400;
  font-size: 14px;
  color: #09091a;
  margin-left: 4px;
`;
